import { Dto } from '@core/data/dto/dto';
import { DtoForceConstructor, DtoImport, DtoExport } from '@core/utils/dto';
import { DTO_DEFAULT } from '@core/data/dto/dto-types';
import { DtoType } from '@core/data/dto/dto-types';
import { MiscellaneousSchema } from './miscellaneous.schema';

@DtoForceConstructor
export class Miscellaneous implements Dto {

    public amount: number;
    public annualLimit: number;
    public percent: number;
    public maxPercent: number;
    public totalAmount: number;
    public priority: number;

    @DtoImport(MiscellaneousSchema)
    static import(dto: Dto): Miscellaneous {
        return new Miscellaneous(dto);
    }

    constructor(value?: any) {
        if (value) {
            const properties: string[] = Object.keys(value);

            properties.forEach((property: string) => {
                this[property] = value[property];
            });
        }
    }

    @DtoExport([
        {
            type: DTO_DEFAULT,
            dto: MiscellaneousSchema,
        },
    ])
    export(type?: DtoType): any {}  
}
